'use es6';

import { useState, useEffect, useCallback } from 'react';
import { offset } from '@floating-ui/react';
import FindReplace from 'rich-text-lib/components/findreplace/FindReplace';
import SimpleFloaty from './SimpleFloaty';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FindReplacePopover(props) {
  const {
    editor,
    onFind,
    onDone
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [searchCount, setSearchCount] = useState(0);
  const [searchIndex, setSearchIndex] = useState(0);
  const [findValue, setFindValue] = useState('');
  const blurEvents = editor.settings.blurEvents || 'blur remove';
  const resetSearchCount = () => {
    setSearchCount(0);
    setSearchIndex(0);
  };
  const handleFindNext = () => {
    if (searchIndex < searchCount) {
      props.onFindNext();
      setSearchIndex(searchIndex + 1);
    }
  };
  const handleFindPrev = () => {
    if (searchIndex > 1) {
      props.onFindPrev();
      setSearchIndex(searchIndex - 1);
    }
  };
  const handleFindInputChange = useCallback(value => {
    const count = onFind(value);
    setSearchCount(count);
    setSearchIndex(count && 1);
    setFindValue(value);
  }, [onFind]);
  const handleReplaceAll = replacementValue => {
    props.onReplaceAll(replacementValue);
    if (replacementValue.indexOf(findValue) >= 0) {
      // Search again if findValue is a substring of the replacementValue
      handleFindInputChange(findValue);
    } else {
      resetSearchCount();
    }
  };
  const handleRemove = useCallback(() => {
    onDone();
    setIsOpen(false);
    resetSearchCount();
    setFindValue('');
  }, [onDone]);
  useEffect(() => {
    editor.on(blurEvents, handleRemove);
    return () => {
      editor.off(blurEvents, handleRemove);
    };
  }, [editor, handleRemove, blurEvents]);
  useEffect(() => {
    const handleOpen = () => {
      const selectedText = editor.selection.getContent({
        format: 'text'
      }).trim();
      handleFindInputChange(selectedText);
      setIsOpen(true);
    };
    editor.on('OpenFindReplace', handleOpen);
    return () => {
      editor.off('OpenFindReplace', handleOpen);
    };
  }, [editor, handleFindInputChange]);
  if (!isOpen) return null;
  const toolbar = document.querySelector('[data-test-id="canvas-toolbar"]');
  return /*#__PURE__*/_jsx(SimpleFloaty, {
    target: toolbar,
    placement: "bottom-end",
    middleware: [offset(editor.settings.inline ? {
      crossAxis: -20
    } : {
      mainAxis: -1,
      crossAxis: 1
    })],
    children: /*#__PURE__*/_jsx(FindReplace, {
      open: isOpen,
      searchCount: searchCount,
      searchIndex: searchIndex,
      findValue: findValue,
      onFindInputChange: handleFindInputChange,
      onFindNext: handleFindNext,
      onFindPrev: handleFindPrev,
      onToggleShowReplace: props.onToggleShowReplace,
      onReplaceAll: handleReplaceAll,
      onClose: handleRemove
    })
  });
}